const TabDimensions = ({item}) => {
    return (
        <>
            <div className="container">
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="container_tag" className="col-form-label">
                            Modelo contenedor
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="text"
                            className="form-control"
                            id="container_tag"
                            name="container_tag"
                            defaultValue={item.model_name}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="manufactured" className="col-form-label">
                            Fabricante
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="text"
                            className="form-control"
                            id="manufactured"
                            name="manufactured"
                            defaultValue={item.manufactured}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="c_factor" className="col-form-label">
                            Factor C
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="number"
                            className="form-control text-end"
                            id="c_factor"
                            name="c_factor"
                            defaultValue={item.c_factor}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="d_factor" className="col-form-label">
                            Factor D (kg/m3)
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="number"
                            className="form-control text-end"
                            id="d_factor"
                            name="d_factor"
                            defaultValue={item.d_factor}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="offset" className="col-form-label">
                            OffSet
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="number"
                            className="form-control text-end"
                            id="offset"
                            name="offset"
                            defaultValue={item.offset}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="height" className="col-form-label">
                            Altura
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="number"
                            className="form-control text-end"
                            id="height"
                            name="height"
                            defaultValue={item.height}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="volume" className="col-form-label">
                            Volumen
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="number"
                            className="form-control text-end"
                            id="volume"
                            name="volume"
                            defaultValue={item.volume}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-md-4 col-12 text-end">
                        <label htmlFor="threshold" className="col-form-label">
                            Umbral de llenado (%)
                        </label>
                    </div>
                    <div className="col-md-3 col-12">
                        <input
                            type="number"
                            className="form-control text-end"
                            id="threshold"
                            name="threshold"
                            defaultValue={item.threshold}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
export default TabDimensions;
